import PropTypes from 'prop-types';
import styled from 'styled-components';

import { getExpirationStatus, getFileNameWithoutExtension } from './IncomeDocumentUtils';
import ClampedText from '../../ClampedText';
import { getApplicantFirstName } from '../../../utils/applicantDetailsUtil';

const Wrapper = styled.div`
  overflow: hidden;
  padding-left: 1rem;
`;

export default function IncomeDocumentInfo({ applicant, fileName, expirationFloat }) {
  const expirationDateUtc = new Date(expirationFloat);
  const expirationStatus = getExpirationStatus(expirationDateUtc);

  return (
    <Wrapper className="incomeDocuments__fileInfo">
      <ClampedText
        className="incomeDocuments__fileInfo--applicantName"
        fontType="body"
        as="b"
        paddingRight="xs"
        paddingBottom="sm"
        maxLines={1}
      >
        {getApplicantFirstName(applicant?.answers)}
      </ClampedText>
      <ClampedText
        className="incomeDocuments__fileInfo--fileName"
        fontType="bodySmall"
        as="b"
        paddingRight="xs"
        paddingBottom="sm"
        maxLines={2}
      >
        {getFileNameWithoutExtension(fileName)}
      </ClampedText>
      <ClampedText
        className="incomeDocuments__fileInfo--expirationStatus"
        fontType="finePrint"
        as="p"
        paddingRight="xs"
        maxLines={1}
        title={expirationStatus}
      >
        {expirationStatus}
      </ClampedText>
    </Wrapper>
  );
}

IncomeDocumentInfo.propTypes = {
  fileName: PropTypes.string.isRequired,
  expirationFloat: PropTypes.number.isRequired,
};
